<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.denominacion' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.producto' | translate}} *</label>
            <app-filterable-list [itemsList]="productos" [selectedItem]="newEditForm.get('productoId')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.alias' | translate}} </label>
            <input type="text" formControlName="alias">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.etiquetaCaja' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="etiquetasCaja" [selectedItem]="newEditForm.get('disenyoEtiquetasIdCaja')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.etiquetaPallet' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="etiquetasPallet" [selectedItem]="newEditForm.get('disenyoEtiquetasIdPallet')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.grupoEtiquetaCaja' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="grupoEtiquetasCaja" [selectedItem]="newEditForm.get('grupoEtiquetasIdCaja')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.grupoEtiquetaPallet' | translate}}</label>
            <app-filterable-list class="short-list" [itemsList]="grupoEtiquetasPallet" [selectedItem]="newEditForm.get('grupoEtiquetasIdPallet')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.nombreArchivoImagen' | translate}}</label>
            <input type="text" formControlName="nombreArchivoImagen">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoDenominaciones.table.denominacionIntegracionId' | translate}}</label>
            <input type="text" formControlName="denominacionIntegracionId">
        </div>
        <div class="entry-4-modal alignment-start">
            <input type="checkbox" id="permisoLectura" formControlName="permisoLectura">
            <label for="permisoLectura">{{'mantenimientoDenominaciones.table.permisoLectura' | translate}} *</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{denominacionId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
